var React = require('react');

function SpeakerUrlFacebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#speaker-url-facebook)","key":0},React.createElement("path",{"fill":"#3273E0","d":"M11.9986 2.98875h1.6433v-2.862C13.3584.08775 12.3834 0 11.2479 0 8.87861 0 7.25561 1.49025 7.25561 4.22925V6.75h-2.6145v3.1995h2.6145V18h3.20549V9.95025h2.5088l.3982-3.1995h-2.9077V4.5465c.0007-.92475.2497-1.55775 1.5382-1.55775Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"speaker-url-facebook"},React.createElement("path",{"fill":"#fff","d":"M0 0h18v18H0z","transform":"translate(.00098)"})))]);
}

SpeakerUrlFacebook.defaultProps = {"fill":"none","viewBox":"0 0 18 18"};

module.exports = SpeakerUrlFacebook;

SpeakerUrlFacebook.default = SpeakerUrlFacebook;
